import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Table, DatePicker, Tag, Input, Select} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const CalendarIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [calendarPageIndex, setCalendarPageIndex] = useState(1);
    const [calendarPageSize, setCalendarPageSize] = useState(store.main.pageSize);
    const [calendarIdList, setCalendarIdList] = useState([]);
    const [calendarTotal, setCalendarTotal] = useState(0);
    const [calendarList, setCalendarList] = useState([]);
    const [activityList, setActivityList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/calendar/index"});

            handleSearchCalendar();
            handleLoadActivitySelect();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadCalendar(calendarPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadCalendar(calendarPageIndex, calendarPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchCalendar = () => {
        handleLoadCalendar(1, calendarPageSize);
    };

    const handleLoadCalendar = (calendarPageIndex, calendarPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        if (data.calendarDate) {
            data.calendarDate = data.calendarDate.format("YYYY-MM-DD");
        }
        data.pageIndex = calendarPageIndex;
        data.pageSize = calendarPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/calendar/business/website/v1/list",
            data: data,
            success: (response) => {
                setCalendarPageIndex(calendarPageIndex);
                setCalendarPageSize(calendarPageSize);
                setCalendarIdList([]);
                setCalendarTotal(response.data.total);
                setCalendarList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddCalendar = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/calendar/add",
        });
    };

    const handleEditCalendar = (calendarId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/calendar/edit/" + calendarId,
        });
    };

    const handleDelCalendar = () => {
        if (calendarIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/calendar/business/website/v1/delete",
                    data: {
                        calendarIdList: calendarIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setCalendarIdList([]);

                        handleLoadCalendar(calendarPageIndex, calendarPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeCalendarIdList = (calendarIdList) => {
        setCalendarIdList(calendarIdList);
    };

    const handleChangeCalendarPagination = (calendarPageIndex, calendarPageSize) => {
        handleLoadCalendar(calendarPageIndex, calendarPageSize);
    };


    const handleLoadActivitySelect = () => {
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/activity/business/website/v1/select/list",
            data: {},
            success: (response) => {
                setActivityList(response.data);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {},
        });
    };

    const getActivityName=(activityId)=>{
        for (let obj of activityList) {
            if (obj.activityId === activityId){
                return obj.activityName
            }
        }
        return "不限"
    }

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddCalendar}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={calendarIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelCalendar}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchCalendar}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="采购活动"
                                labelAlign={"left"}
                                name="activityId"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请选择活动",
                                    },
                                ]}
                            >
                                <Select
                                    className={Style.card_field}
                                    placeholder="请选择活动名称"
                                >
                                    <Select.Option value={""}>
                                        全部活动
                                    </Select.Option>
                                    {activityList.map((activity, activityIndex) => {
                                        return (
                                            <Select.Option key={activityIndex} value={activity.activityId}>
                                                {activity.activityName}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="日历日期"
                                labelAlign={"left"}
                                name="calendarDate"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请选择日历日期",
                                    },
                                ]}
                            >
                                <DatePicker
                                    className={Style.card_field}
                                    format="YYYY-MM-DD"
                                    placeholder="请选择日历日期"
                                    onPressEnter={handleSearchCalendar}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="商户名称"
                                labelAlign={"left"}
                                name="merchantName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入商户名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入商户名称" onPressEnter={handleSearchCalendar} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="门店名称"
                                labelAlign={"left"}
                                name="shopName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入门店名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入门店名称" onPressEnter={handleSearchCalendar} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.calendarId}
                        columns={[
                            {
                                title: "采购商活动",
                                width: 300,
                                dataIndex: "activityId",
                                render:(text,record,index)=>getActivityName(record.activityId)
                            },
                            {
                                title: "日历日期",
                                width: 150,
                                dataIndex: "calendarDate",
                            },
                            {
                                title: "排除门店",
                                dataIndex: "calendarIsAll",
                                render: (text, record, recordIndex) => (
                                    <div>
                                        {record.calendarIsAll ? (
                                            <Tag color="blue">全部门店</Tag>
                                        ) : (
                                            <div>
                                                {record.calendarShopList.map((calendarShop, calendarShopIndex) => {
                                                    return (
                                                        <div key={calendarShopIndex}>
                                                            {calendarShop.merchantName} - {calendarShop.shopName} - {calendarShop.restStart} ~{" "}
                                                            {calendarShop.restEnd}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                ),
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditCalendar(record.calendarId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={calendarList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: calendarIdList,
                            onChange: handleChangeCalendarIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: calendarPageIndex,
                            pageSize: calendarPageSize,
                            total: calendarTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeCalendarPagination,
                            onShowSizeChange: handleChangeCalendarPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

CalendarIndex.propTypes = {};

CalendarIndex.defaultProps = {};

export default CalendarIndex;
